import { Link } from "react-router-dom";
import { ArrowRight, XCircle } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function Cancel() {
  return (
    <div className="min-h-screen">
      <Nav />
      <section className="max-w-4xl mx-auto px-6 sm:px-10 py-20 lg:py-28" data-testid="cancel-section">
        <div className="text-[11px] uppercase tracking-[0.3em] font-bold text-[#D92D20] mb-4">Payment cancelled</div>
        <div className="flex items-start gap-5">
          <XCircle className="w-12 h-12 text-[#525252] shrink-0 mt-1" />
          <h1 className="font-display font-black tracking-tighter text-5xl sm:text-6xl leading-[0.92]">
            No charges made.<br />Your cart is still here.
          </h1>
        </div>
        <p className="mt-8 max-w-xl text-lg text-[#525252] leading-relaxed">
          The payment was cancelled before completion. You can resume checkout anytime.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/checkout" className="inline-flex items-center gap-3 bg-[#D92D20] text-white px-7 py-4 hover:bg-[#B42318]" data-testid="resume-btn">
            Order Your Copy <ArrowRight className="w-5 h-5" />
          </Link>
          <Link to="/" className="inline-flex items-center gap-3 border border-[#0A0A0A] px-7 py-4 hover:bg-[#0A0A0A] hover:text-white" data-testid="cancel-home-btn">
            Back to book
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
